import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "content_accordion" }
const _hoisted_2 = { class: "product_tit" }
const _hoisted_3 = { class: "product_txt" }
const _hoisted_4 = {
  key: 0,
  class: "lst_noti"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: ["product_information_bx", {'is-expanded': _ctx.showNotice}]
  }, [
    _createVNode("button", {
      class: "ltem_accordion",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleNotice && _ctx.toggleNotice(...args)))
    }, "상품 고시 정보"),
    _withDirectives(_createVNode("dl", _hoisted_1, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.product.notices, (notice, index) => {
        return (_openBlock(), _createBlock("div", { key: index }, [
          _createVNode("dt", _hoisted_2, _toDisplayString(notice.noticeName), 1),
          _createVNode("dd", _hoisted_3, [
            (_ctx.hasNewlineCharacter(notice.noticeDescription))
              ? (_openBlock(), _createBlock("ul", _hoisted_4, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.convertToMultiLineString(notice.noticeDescription), (descriptoin, index2) => {
                    return (_openBlock(), _createBlock("li", { key: index2 }, _toDisplayString(descriptoin), 1))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(notice.noticeDescription), 1)
                ], 64))
          ])
        ]))
      }), 128))
    ], 512), [
      [_vShow, _ctx.showNotice]
    ])
  ], 2))
}